import React from "react";
import { OnboardingSubtask } from "../types";

interface OnboardingSubtaskItemProps {
  taskId: string;
  subtask: OnboardingSubtask;
  onToggle: (taskId: string, subtaskId: string) => Promise<void>;
  isCompleted?: boolean;
}

export const OnboardingSubtaskItem: React.FC<OnboardingSubtaskItemProps> = ({
  taskId,
  subtask,
  onToggle,
  isCompleted,
}) => {
  return (
    <div className="flex items-center py-1">
      <label className="flex items-center flex-1 cursor-pointer">
        <input
          type="checkbox"
          className="form-checkbox w-4 h-4 rounded-full peer cursor-pointer"
          checked={subtask.completed}
          onChange={() => onToggle(taskId, subtask.id)}
        />
        <span
          className={`text-sm text-gray-800 dark:text-gray-100 peer-checked:line-through ml-3 ${
            isCompleted ? "opacity-60" : ""
          }`}
        >
          {subtask.title}
        </span>
      </label>
    </div>
  );
};
